import React, { useEffect, useState } from "react";
import { useSpring, animated, useSpringRef, useChain } from "@react-spring/web";

const CustomCursor = ({ isHovering, animateRing }) => {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  // Main cursor animation
  const cursorSpring = useSpring({
    left: pos.x - (isHovering ? 35 : 22.5),
    top: pos.y - (isHovering ? 35 : 22.5),
    width: isHovering ? 70 : 45,
    height: isHovering ? 70 : 45,
    border: isHovering
      ? "4px solid rgba(235, 243, 11, 0.1)"
      : "2px solid rgba(255, 255, 255, 0.5)",
    backgroundColor: isHovering
      ? "rgba(235, 243, 11, 0.5)"
      : "transparent",
    config: { tension: 250, friction: 20 },
  });

  // Ring effect animation
  const ringSpringRef = useSpringRef();
  const ringSpring = useSpring({
    ref: ringSpringRef,
    from: {
      left: pos.x - 35,
      top: pos.y - 35,
      width: 70,
      height: 70,
      opacity: 0.5,
      transform: "scale(1)",
    },
    to: animateRing
      ? async (next) => {
          await next({ transform: "scale(2)", opacity: 0 });
        }
      : {},
    config: { tension: 120, friction: 14 },
    reset: true,
  });

  useChain(animateRing ? [ringSpringRef] : []);

  // Track mouse movement
  useEffect(() => {
    const moveHandler = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener("mousemove", moveHandler);
    return () => window.removeEventListener("mousemove", moveHandler);
  }, []);

  return (
    <>
      {/* Ripple Animation Circle */}
      {animateRing && (
        <animated.div
          style={{
            position: "fixed",
            borderRadius: "50%",
            border: "2px solid rgba(235, 243, 11, 0.4)",
            backgroundColor: "transparent",
            pointerEvents: "none",
            zIndex: 9998,
            ...ringSpring,
          }}
        />
      )}

      {/* Main Cursor */}
      <animated.div
        style={{
          position: "fixed",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 9999,
          ...cursorSpring,
        }}
      />
    </>
  );
};

export default CustomCursor;
